import React, {useEffect} from "react";
import {Link, useLocation} from "react-router-dom";

interface Props {
    title: string;
    children: React.ReactNode;
    lastUpdated?: string;
}

export default function LegalLayout({title, children, lastUpdated}: Props): JSX.Element {
    const {pathname} = useLocation();

    // Reset scroll on every legal-page navigation so users don't land mid-document
    // when jumping between Privacy / Terms / Course Terms via the footer links.
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <main style={{
            background: "#0b1410",
            color: "#fff",
            minHeight: "100vh",
            paddingBottom: "5rem",
        }}>
            <header style={{padding: "1.5rem 1.25rem", maxWidth: 880, margin: "0 auto"}}>
                <Link to="/" style={{
                    fontWeight: 700,
                    fontSize: "1rem",
                    letterSpacing: "0.04em",
                    color: "#2ad167",
                    textDecoration: "none",
                }}>
                    EFFECTIVE ACTION SYSTEM
                </Link>
            </header>

            <article style={{
                maxWidth: 880,
                margin: "0 auto",
                padding: "1.5rem 1.25rem 0",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                fontSize: "1rem",
                lineHeight: 1.65,
                color: "rgba(255,255,255,0.85)",
            }}>
                <h1 style={{
                    fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
                    fontWeight: 700,
                    margin: "0 0 0.5rem",
                    color: "#fff",
                    lineHeight: 1.15,
                }}>
                    {title}
                </h1>
                {lastUpdated && (
                    <p style={{
                        margin: "0 0 2rem",
                        color: "rgba(255,255,255,0.55)",
                        fontSize: "0.9rem",
                    }}>
                        Last updated: {lastUpdated}
                    </p>
                )}
                <div className="legal-content">
                    {children}
                </div>
            </article>

            <footer style={{
                maxWidth: 880,
                margin: "3rem auto 0",
                padding: "2rem 1.25rem",
                borderTop: "1px solid rgba(255,255,255,0.1)",
                fontSize: "0.85rem",
                color: "rgba(255,255,255,0.5)",
            }}>
                <div style={{display: "flex", flexWrap: "wrap", gap: "1.5rem"}}>
                    <Link to="/" style={legalFooterLinkStyle}>Home</Link>
                    <Link to="/legal/privacy" style={legalFooterLinkStyle}>Privacy policy</Link>
                    <Link to="/legal/terms" style={legalFooterLinkStyle}>Terms of service</Link>
                </div>
                <p style={{margin: "1rem 0 0"}}>
                    PRODUKACJA Sp. z o.o., ul. Wyścigowa 63, 53-011 Wrocław, Poland · KRS 0001098787 · NIP 8992990210
                </p>
            </footer>
            <style>{`
                .legal-content h2 {
                    font-size: clamp(1.25rem, 2.4vw, 1.6rem);
                    color: #fff;
                    margin: 2.5rem 0 1rem;
                    font-weight: 600;
                    line-height: 1.25;
                }
                .legal-content h3 {
                    font-size: 1.1rem;
                    color: #fff;
                    margin: 1.75rem 0 0.5rem;
                    font-weight: 600;
                }
                .legal-content p {
                    margin: 0 0 1rem;
                }
                .legal-content ul, .legal-content ol {
                    margin: 0 0 1rem;
                    padding-left: 1.5rem;
                }
                .legal-content li {
                    margin: 0 0 0.4rem;
                }
                .legal-content a {
                    color: #2ad167;
                    text-decoration: underline;
                }
            `}</style>
        </main>
    );
}

const legalFooterLinkStyle: React.CSSProperties = {
    color: "rgba(255,255,255,0.55)",
    textDecoration: "none",
};
